export default [
    '18 18',
    '<path id="Icon" d="M15.75 15.75H2.25M13.5 8.25L9 12.75M9 12.75L4.5 8.25M9 12.75V2.25" fill="none" stroke="var(--p-icon-color, currentColor)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
]